import React from "react";
import mathService from "../services/math.service";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Cart, Heart,HeartFill } from "react-bootstrap-icons";

const Posts = ({ post }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const imageURL = post?.media?.[0]?.image?.image?.replace(
    /\/media\/(marketplace\/)?/g,
    ""
  );

  const { offPercent } = mathService.discountRate(
    post?.stock?.mrp,
    post?.stock?.selling_price
  );

  const handleNavigate = () =>
    navigate(`/productdetail/${post?.product.id}`, {
      state: { productId: post?.product.id },
    });

  return (
    <div className="post">
      <div className="post-product-image" onClick={handleNavigate}>
        <img
          className="post-image"
          src={imageURL}
          style={{ aspectRatio: 1, objectFit: "contain" }}
          alt={post?.product?.name}
        />
      </div>

      <div className="post-product-detail" style={{ borderTop: "3px solid #BFE2BA" }}>
        <div className="post-name-brand">
          <div className="post-product-name">{post?.product?.name}</div>
          <div className="post-product-brand">By {post?.product?.brand?.name}</div>
        </div>

        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="post-rating">
              {[...Array(5)].map((_, key) => (
                <i key={key} style={{ color: "gold" }} className="far fa-star" />
              ))}
            </div>

            {post?.product?.product_type === 1 ? (
              <strong className="post-offpercent">{offPercent && `${offPercent}% off`}</strong>
            ) : (
              <div>Send Quote</div>
            )}
          </div>

          {post?.product?.product_type === 1 && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <strong className="post-selling-price">₹ {post?.stock?.selling_price}</strong>
              <strike className="post-mrp">MRP : ₹ {post?.stock?.mrp}</strike>
            </div>
          )}
        </div>

        <div className="cart-wishlist-container">
          <button className="cart-button" onClick={handleNavigate}>
            <Cart size={24} />
            <span>Add to Cart</span>
          </button>
          {true?<Heart size={24} onClick={() => null} />:
          <HeartFill size={24} color="red" onClick={() => null} />}
        </div>
      </div>
    </div>
  );
};

export default Posts;
